"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
if (process.env.NODE_ENV !== "production") {
    Promise.resolve().then(() => __importStar(require("@babylonjs/core/Debug/debugLayer")));
    Promise.resolve().then(() => __importStar(require("@babylonjs/inspector")));
}
// ES6 IMPORTS
// if there are cases where es6 dependencies could be causing issues just try and load the whole babylon core, and
// that fixes it, then it is a dependencies issue, check this link out for answers.
// bjs post: https://forum.babylonjs.com/t/pickedmesh-is-null-in-onpointerobservable-after-update-to-6-25-0/45076/7
// bjs docs: https://doc.babylonjs.com/setup/frameworkPackages/es6Support#faq
require("@babylonjs/core/Culling/ray");
require("@babylonjs/core/Animations/animatable");
require("@babylonjs/core/Lights/Shadows/shadowGeneratorSceneComponent");
require("@babylonjs/core/Loading/loadingScreen");
require("@babylonjs/loaders/glTF/2.0/glTFLoader");
require("@babylonjs/loaders/glTF/2.0/Extensions/KHR_materials_pbrSpecularGlossiness");
require("@babylonjs/loaders/glTF/2.0/Extensions/KHR_draco_mesh_compression");
require("@babylonjs/core/Rendering/depthRendererSceneComponent");
require("@babylonjs/core/Rendering/outlineRenderer");
require("@babylonjs/core/Audio/audioSceneComponent");
const dracoCompression_1 = require("@babylonjs/core/Meshes/Compression/dracoCompression");
dracoCompression_1.DracoCompression.Configuration = {
    decoder: {
        wasmUrl: "/lib/draco_wasm_wrapper_gltf.js",
        wasmBinaryUrl: "/lib/draco_decoder_gltf.wasm",
        fallbackUrl: "/lib/draco_decoder_gltf.js",
    },
};
const engine_1 = require("@babylonjs/core/Engines/engine");
const Screens_1 = __importDefault(require("./Screens/Screens"));
const LoginScene_1 = require("./Screens/LoginScene");
const CharacterSelection_1 = require("./Screens/CharacterSelection");
const CharacterEditor_1 = require("./Screens/CharacterEditor");
const GameScene_1 = require("./Screens/GameScene");
const DebugScene_1 = require("./Screens/DebugScene");
const Config_1 = require("../shared/Config");
const Loading_1 = require("./Controllers/Loading");
const Utils_1 = require("./Utils");
const GameController_1 = require("./Controllers/GameController");
// App class is our entire game application
class App {
    constructor() {
        // create canvas
        this.canvas = document.getElementById("renderCanvas");
        // set config
        this.config = new Config_1.Config();
        // initialize babylon scene and engine
        this._init();
    }
    _init() {
        return __awaiter(this, void 0, void 0, function* () {
            // create engine
            this.engine = new engine_1.Engine(this.canvas, true, {
                adaptToDeviceRatio: true,
                antialias: true,
            });
            //
            this.engine.setHardwareScalingLevel(1);
            // loading
            var loadingScreen = new Loading_1.Loading("Loading Assets...");
            this.engine.loadingScreen = loadingScreen;
            // preload game data
            this.game = new GameController_1.GameController(this);
            yield this.game.initializeGameData();
            // set default scene
            let defaultScene = (0, Utils_1.isLocal)() ? Screens_1.default.GAME : Screens_1.default.LOGIN;
            this.game.setScene(defaultScene);
            // main render loop & state machine
            yield this._render();
        });
    }
    _render() {
        return __awaiter(this, void 0, void 0, function* () {
            // render loop
            this.engine.runRenderLoop(() => {
                // monitor state
                this.game.state = this.checkForSceneChange();
                switch (this.game.state) {
                    ///////////////////////////////////////
                    // LOGIN SCENE
                    case Screens_1.default.LOGIN:
                        this.clearScene();
                        this.game.currentScene = new LoginScene_1.LoginScene();
                        this.createScene();
                        break;
                    ///////////////////////////////////////
                    // CHARACTER SELECTION SCENE
                    case Screens_1.default.CHARACTER_SELECTION:
                        this.clearScene();
                        this.game.currentScene = new CharacterSelection_1.CharacterSelectionScene();
                        this.createScene();
                        break;
                    ///////////////////////////////////////
                    // CHARACTER SELECTION SCENE
                    case Screens_1.default.CHARACTER_EDITOR:
                        this.clearScene();
                        this.game.currentScene = new CharacterEditor_1.CharacterEditor();
                        this.createScene();
                        break;
                    ///////////////////////////////////////
                    // GAME
                    case Screens_1.default.GAME:
                        this.clearScene();
                        this.game.currentScene = new GameScene_1.GameScene();
                        this.createScene();
                        break;
                    ///////////////////////////////////////
                    // DEBUG
                    case Screens_1.default.DEBUG_SCENE:
                        this.clearScene();
                        this.game.currentScene = new DebugScene_1.DebugScene();
                        this.createScene();
                        break;
                    default:
                        break;
                }
                // render when scene is ready
                this._process();
            });
            //for development: make inspector visible/invisible
            if ((0, Utils_1.isLocal)()) {
                window.addEventListener("keydown", (ev) => {
                    //Shift+Ctrl+Alt+I
                    if (ev.shiftKey && ev.ctrlKey && ev.altKey && ev.keyCode === 73) {
                        if (this.game.scene.debugLayer.isVisible()) {
                            this.game.scene.debugLayer.hide();
                        }
                        else {
                            this.game.scene.debugLayer.show();
                        }
                    }
                });
            }
            //resize if the screen is resized/rotated
            window.addEventListener("resize", () => {
                this.engine.resize();
                if (this.game.currentScene && this.game.currentScene.resize) {
                    this.game.currentScene.resize();
                }
            });
        });
    }
    createScene() {
        this.game.currentScene.createScene(this.game);
        this.game.scene = this.game.currentScene._scene;
        this.game.state = Screens_1.default.NULL;
    }
    checkForSceneChange() {
        let currentScene = this.game.nextScene;
        if (this.game.nextScene !== Screens_1.default.NULL) {
            this.game.nextScene = Screens_1.default.NULL;
            return currentScene;
        }
    }
    _process() {
        return __awaiter(this, void 0, void 0, function* () {
            // make sure scene and camera is initialized
            if (this.game.scene && this.game.scene.activeCamera) {
                // render scene
                //this.game.currentScene.engineUpdate();
                this.game.scene.render();
            }
        });
    }
    clearScene() {
        if (this.game.scene) {
            this.game.engine.displayLoadingUI();
            this.game.scene.detachControl();
            this.game.scene.dispose();
            this.game.currentScene = null;
        }
    }
}
new App();
